const firebaseConfig = import.meta.env?.VITE_FB_JUNO
const backendUrl = import.meta.env?.VITE_API_URL
const ddClientToken = import.meta.env?.VITE_DATADOG_CLIENT_TOKEN
const environment = import.meta.env?.VITE_ENV || 'local'

export const FIREBASE_CONFIG = JSON.parse(atob(firebaseConfig))
export const BACKEND_URL = backendUrl
export const DD_CLIENT_TOKEN = ddClientToken
export const ENVIRONMENT = environment
